
export default {
    name: "popup_login_streak",
    props: ["loginStreak"],
    data(){
        return {
            isLoading: false,
            isCheckedIn: false,
            streakDays: 42,
            checkedInStreak: 0,
        }
    },
    computed: {
        currentStreak(){
            return this.checkedInStreak || this.loginStreak?.streak || 0;
        },
        streakContent(){
            return this.getStreakContent(this.currentStreak);
        },
        streakMilestones(){
            return Object.keys(this.streakMap).map(Number);
        },
    },
    mounted(){
        this.onSubmitCheckin();
    },
    methods: {
        onSubmitCheckin(){
            if(this.isLoading || this.isCheckedIn) return;
            this.isLoading = true;

            this.$axios.$post(`/auth/checkin`, {}, this.tokenHeader).then(res => {
                console.log("checkinCallback", res);
                this.isLoading = false;
                this.isCheckedIn = true;
                this.checkedInStreak = res.item?.streak || this.currentStreak;
                this.onHandleTriggerAnalytics(`checkin`);
                if(res.stamp) this.$store.commit("stamp/addItem", res.stamp);
            }).catch(err => {
                console.log("checkinError", err);
                this.isLoading = false;
                this.onHandleApiError(err);
            });
        },
    	onClickCheckinBtn(){
            if(this.isLoading) return;

            if(!this.isCheckedIn) return this.onSubmitCheckin();
            this.$emit("update:loginStreak", { hasCheckin: true, streak: this.checkedInStreak });
        }
    },
    watch: {

    }
}
